import { render, staticRenderFns } from "./CommentControl.vue?vue&type=template&id=6cb968bb&scoped=true"
import script from "./CommentControl.vue?vue&type=script&lang=js"
export * from "./CommentControl.vue?vue&type=script&lang=js"
import style0 from "./CommentControl.vue?vue&type=style&index=0&id=6cb968bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb968bb",
  null
  
)

export default component.exports